export const defaultLocale = 'en';
export const localeOptions = [
	{id: 'en', name: 'English', icon: 'flag-icon-us'},
	{id: 'bg', name: 'Bulgarian', icon: 'flag-icon-bg'},
	{id: 'fr', name: 'Français', icon: 'flag-icon-fr'},
	{id: 'sk', name: 'Slovenský', icon: 'flag-icon-sk'},
	{id: 'sl', name: 'Slovene', icon: 'flag-icon-sl'},
];